import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { GetAllowCICO } from './__generated__/GetAllowCICO';
import { GET_ALLOW_CICO } from './allow-cico.gql';

export function AllowCICO() {
  const [queryAllowCICO] = useCampfireLazyQuery<GetAllowCICO, {}>(GET_ALLOW_CICO);
  const [allowCICO, setAllowCICO] = React.useState<boolean | undefined>();
  const { setSnackbar } = useSnackbar();

  React.useEffect(() => {
    queryAllowCICO({}).then((response) =>
      setAllowCICO(
        response.data?.vm.configItem?.defaultValue || response.data?.vm.configItem?.configItemValue?.flagValue
      )
    );
  }, []);

  const saveAllowCICO = useCampfireFetch({ defer: true });

  const apiUrl = useApiUrl();
  const onSave = () => {
    saveAllowCICO
      .run({
        url: `${apiUrl}/vm/admin-console/operations/allow-cico`,
        method: 'post',
        data: {
          value: !allowCICO,
        },
      })
      .then(() => {
        setSnackbar({
          open: true,
          message: 'Successfully updated',
          variant: 'success',
        });
      });
    setAllowCICO(!allowCICO);
  };

  return (
    <Box mt={2}>
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={Boolean(allowCICO)}
          onChange={onSave}
          color='primary'
          inputProps={{ 'aria-label': 'check in check out' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            Check In/Check Out
          </Typography>
          <Typography variant={'body2'} style={{ fontSize: '13px', color: '#808080' }}>
            {
              'Volunteers will be able to check in to and out of rostered sessions, allowing recording of more accurate impact hours.'
            }
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
